<template>
  <div class="property-listed-upload" v-show="selected">
    <div class="form-group">
      <p>Upload listing agreement</p>

      <file-input
        class = "subsection"
        :placeholder="'Drop Listing Agreement files here to upload PDF, JPG, PNG up to 10MB'"
        :label="form.uploadedFiles.label"
        :isMandatory="true"
        @file-uploading="fileUploading"
        @validated-fields="validate"
        @input="onFileInput"
      />

      <div class="subsection">
        <oa-button
          :text="'Upload & mark as listed'"
          :btnClass="{ color: 'green' }"
          :disabled="disableValidateButton"
          @click="clickedValidate"
          v-gaEvent="gaEvent('Leads Management - Click update lead submit - Listed')"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import { LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';
import { LeadStageType, LeadStageTypeId } from '@/Mapper/LeadStageType';
import OaButton from '@/components/Forms/OaButton';
import FileInput from '@/components/Forms/FileInput.vue';
import StageUpdate from '@/mixins/StageUpdate';
import StageChangeListed from '@/mixins/StageChangeListed';
import AgentFileUpload from '@/mixins/AgentFileUpload';
import FileUpload from '@/mixins/FileUpload';
import FormHandler from '@/mixins/FormHandler';

export default {
  name: 'PropertyListingUpload',
  mixins: [
    FileUpload,
    FormHandler,
    StageChangeListed,
    StageUpdate,
  ],
  components: {
    FileInput,
    OaButton,
  },
  props: {
    selected: {
      default: false,
    },
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      lead: state => state.leadAgentMappingStore.lead,
    }),
  },
  data() {
    return {
      disableSubmit: false,
      uploadedFiles: [],
      form: {
        uploadedFiles: {
          label: 'Upload your file',
          values: {},
        },
      },
    };
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'uploadFile',
    ]),
    createCaseForListingUpdate() {
      const caseData = {
        leadkey: this.lead.key,
        // agentkey: this.agent.key,
        agentkey: this.$route.params.ak,
        leadstatus: LeadStageTypeId[LeadStageType.Listed],
        comment: 'Listing agreement file uploaded',
      };
      return this.$apiServices.oa.lead.createCaseForLeadUpdate(caseData);
    },
    saveDetails() {
      this.upload()
        .then(() => {
          this.doListedUpdates();
        });
    },
    doListedUpdates() {
      this.disableSubmit = true;
      this.listedUpdates()
        .then(() => {
          this.disableSubmit = false;
        });
    },
    fillFormData(formData, i) {
      const index = parseInt(i, 10) + 1;

      formData.append('uploadname', `Listing_Agreement_Lead_${this.lead.id}_${index}`);
      formData.append('agentkey', this.agent.key);
      formData.append('userkey', this.agent.userkey);
      formData.append('leadkey', this.lead.key);
      formData.append('uploadtypeid', 1);

      return formData;
    },
    onFileInput(values) {
      this.disableSubmit = false;
      this.uploadedFiles = values.value;
      this.onInput(values);
    },
  },
};
</script>

<style lang="scss" scoped>

.property-listed-upload .subsection {
  @apply ut-pt-6;
}

.property-listed-upload p {
  @apply ut-font-normal ut-text-lg ut-pb-3;
  line-height: 28px;
}

</style>
